import { gql } from "@apollo/client";

// Store 정보 공통 fragment
export const STORE_INFO_FRAGMENT = gql`
  fragment StoreInfo on Store {
    id
    lat
    lng
    title
    createdAt
    updatedAt
    isLiked
    distance
    products {
      id
      price
      discountPrice
      saleEndTime
      quantity
      createdAt
      updatedAt
    }
    todaysProducts {
      id
      name
      price
      img
      discountPrice
      userPrice
      saleEndTime
      quantity
      currentCount
      createdAt
      updatedAt
      isEnd
      menus {
        id
        menu {
          id
          name
          img
          price
        }
      }
    }
    img
    contactNumber
    closingHours
    reserveTime
    pack {
      id
      quantity
      price
      discountPrice
      userPrice
      quantity
      currentCount
      isOverTodayPickupTime
      isTodayEnabled
      isTomorrowEnabled
    }
    isProductAllSoldOut
    reviewCount
    likes {
      id
      userId
      storeId
      createdAt
    }
    bestReview {
      id
      content
      createdAt
      isBestReview
      storeId
      reviewImages {
        id
        img
        createdAt
        updatedAt
      }
    }
    availableStoreCoupon {
      id
      title
      discountValue
      minOrderPrice
      endAt
      maxUsageQuantity
      usageCount
      isExpired
      isSoldOut
    }
  }
`;
